import queryApi from './query-api';

export default queryApi;
